<template>
	<div class="sidebar" data-image="./assets/img/sidebar-5.jpg" data-color="cemic" v-if="this.$route.name !== 'Login'">
		<div class="sidebar-wrapper">
			<div class="logo">
				<a href="/" class="simple-text">
					<img src="../assets/logo-c.png">
				</a>
			</div>
			<ul class="nav">
				<li class="nav-item" @click="menuMobile" v-if="esUser()">
					<router-link to="/" exact class="nav-link menu-item" active="false"><i class="nc-icon nc-icon nc-bank"></i><p>Home</p></router-link>
				</li>
				<!-- <li @click="menuMobile">
					<router-link to="/banners" exact class="nav-link menu-item" active="false"><i class="nc-icon nc-album-2"></i><p>Slider Home</p></router-link>
				</li>
				<li @click="menuMobile">
					<router-link to="/categories" exact class="nav-link menu-item" active="false"><i class="nc-icon nc-icon nc-vector"></i><p>Categorias</p></router-link>
				</li>
				<li @click="menuMobile">
					<router-link to="/subcategories" exact class="nav-link menu-item" active="false"><i class="nc-icon nc-icon nc-vector"></i><p>SubCategorias</p></router-link>
				</li>
				<li @click="menuMobile">
					<router-link to="/brands" exact class="nav-link menu-item" active="false"><i class="nc-icon nc-icon nc-tag-content"></i><p>Marcas</p></router-link>
				</li>
				<li @click="menuMobile">
					<router-link to="/products" exact class="nav-link menu-item" active="false"><i class="nc-icon nc-icon nc-cart-simple"></i><p>Productos</p></router-link>
				</li>
				<li @click="menuMobile">
					<router-link to="/sales" exact class="nav-link menu-item" active="false"><i class="nc-icon nc-icon nc-money-coins"></i><p>Pedidos</p></router-link>
				</li> -->
				<li @click="menuMobile" v-if="esUser()">
					<router-link to="/pacientes" exact class="nav-link menu-item" active="false"><i class="nc-icon nc-badge"></i><p>Pacientes</p></router-link>
				</li>
				<li @click="menuMobile" v-if="esUser()">
					<router-link to="/internaciones" exact class="nav-link menu-item" active="true"><i class="nc-icon nc-ambulance"></i><p>Internaciones</p></router-link>
				</li>
				<li @click="menuMobile" v-if="esUser()">
					<router-link to="/cirugias" exact class="nav-link menu-item" active="false"><i class="nc-icon nc-tag-content"></i><p>Cirugias</p></router-link>
				</li>
				<li @click="menuMobile" v-if="esUser()">
					<router-link to="/pase-sala" exact class="nav-link menu-item" active="false"><i class="nc-icon nc-stre-right"></i><p>Pase de sala</p></router-link>
				</li>
				<li @click="menuMobile" v-if="esUser()">
					<router-link to="/estadisticas" exact class="nav-link menu-item" active="false"><i class="nc-icon nc-chart-bar-32"></i><p>Estadisticas</p></router-link>
				</li>	
				<li @click="menuMobile" v-if="esAdministrador()">
					<router-link to="/usuarios" exact class="nav-link menu-item" active="false"><i class="nc-icon nc-circle-09"></i><p>Usuarios</p></router-link>
				</li>
				<li @click="menuMobile" v-if="esFacturacion()">
					<router-link to="/facturacion" exact class="nav-link menu-item" active="false"><i class="nc-icon nc-money-coins"></i><p>Facturacion</p></router-link>
				</li>			
				<!-- <li @click="menuMobile">
					<router-link to="/sales" exact class="nav-link menu-item" active="false"><i class="nc-icon nc-single-02"></i><p>Pacientes</p></router-link>
				</li> -->
				<!-- <li @click="menuMobile">
					<router-link to="/noticias" exact class="nav-link menu-item" active="false"><i class="nc-icon nc-icon nc-paper-2"></i><p>Noticias</p></router-link>
				</li>
				<li @click="menuMobile">
					<router-link to="/about" exact class="nav-link menu-item" active="false"><i class="nc-icon nc-icon nc-single-02"></i><p>About</p></router-link>
				</li>
				<li @click="menuMobile">
					<router-link to="/usuarios" exact class="nav-link menu-item" active="false"><i class="nc-icon nc-circle-09"></i><p>Usuarios</p></router-link>
				</li>
				<li @click="logout">
					<router-link to="#"  exact class="nav-link menu-item" active="false"><i class="nc-icon nc-button-power"></i><p>Cerrar sesion</p></router-link>
				</li> -->
			<!-- <li class="nav-item active active-pro">
				<a class="nav-link active" href="javascript:;">
				<i class="nc-icon nc-alien-33"></i>
				<p>Upgrade plan</p>
				</a>
			</li> -->
			</ul>
		</div>
	</div>
</template>

<script>
import routeService from '../services/route_service.js';
import LoginService from '../services/login_service.js';
//import ConfigService from '../services/config_service.js';
/*import Vue from 'vue';
const configService = new ConfigService();
const config = configService.getConfig();*/
const loginService = new LoginService();
export default {
		data: function() {
			return {
				cerrado: true,
			}
		},
		methods: { 
			menuMobile() {
				if(window.innerWidth < 991) {
					let menu = document.getElementsByClassName("sidebar")[0];
					this.cerrado = menu.className.indexOf("sidebar-open") == -1;
					if(this.cerrado) {
						menu.className = menu.className.replace(/\bsidebar-close\b/g, "");						
						menu.className = menu.className.trim() + " " + "sidebar-open";
						this.cerrado = false;
					} else {
						menu.className = menu.className.replace(/\bsidebar-open\b/g, "");
						menu.className = menu.className.trim() + " " + "sidebar-close";
						this.cerrado = true;
					}
				}
			},
			logout: function () {
				let _this = this;
				loginService.logout({}).then(function() {
					_this.menuMobile();
					routeService.goToLogin();
				}, function(error) { 
					console.log(error);
					_this.menuMobile();
					routeService.goToLogin();
				});
			},
			esAdministrador() {
				return loginService.esAdministrador();
			},
			esUser() {
				return loginService.esUser() || loginService.esAdministrador();
			},
			esFacturacion() {
				return loginService.esFacturacion();
			}
		}
}
</script>
<style scoped>
	/* .menu-item {
		color: #fff !important;
	}

	.router-link-active {
		border-bottom: 2px solid #fff;
	}

	.menu {
		background: #7c94ad !important;
	} */

	/*.nav-item {
		border-top: 1px solid #fff;
		border-bottom: 1px solid #fff;
		border-left: 1px solid #fff;
		font-family: inherit;
		font-size: 12px !important;
		margin: 20px !important;
	}

	ul li:last-child.nav-item{
		border-right: 1px solid #fff;
	}*/
	/* .menu-item {
		font-family: inherit;
		font-size: 12px !important;
		margin: 5px !important;
		text-transform: uppercase;
	}

	@media (min-width: 1200px) {
		.div-nav, .container-xl {
			max-width: 1140px !important;
		}
	}
	@media (min-width: 992px) and (max-width: 1200px) {
		.div-nav {
		max-width: 960px;
		}
	}
	.div-nav {
		width: 100%;
		padding-right: 15px !important;
		padding-left: 15px !important;
		margin-right: auto;
		margin-left: auto;
		margin-bottom: 30px;
	} */
	.router-link-active {
		border-bottom: 2px solid #fff;
	}
</style>
